
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { BlogPost } from '@/types/flotiq';
import { formatPublicationDate } from '@/utils/blogUtils';
import { Calendar } from 'lucide-react';

interface BlogPostCardProps {
  post: BlogPost;
}

const BlogPostCard: React.FC<BlogPostCardProps> = ({ post }) => {
  // Use either publicationDate or publicationdate field
  const publicationDate = post.publicationDate || post.publicationdate;
  
  return (
    <Card className="h-full flex flex-col overflow-hidden transition-shadow duration-200 hover:shadow-lg">
      <Link to={`/blog/${post.slug}`} className="group">
        <CardHeader className="pb-2">
          <h3 className="text-xl font-semibold line-clamp-2 group-hover:text-astrem-black transition-colors">
            {post.title}
          </h3>
        </CardHeader>
        
        <CardContent className="pb-2 flex-grow">
          <p className="text-astrem-gray-600 line-clamp-3">
            {post.excerpt}
          </p>
        </CardContent>
        
        <CardFooter className="pt-0 flex items-center text-sm text-astrem-gray-500">
          <Calendar size={14} className="mr-1" />
          <time dateTime={publicationDate || ''}>
            {publicationDate ? formatPublicationDate(publicationDate) : 'No date available'}
          </time>
        </CardFooter>
      </Link>
    </Card>
  );
};

export default BlogPostCard;
